import { DASHBOARD_MENU_KEY, INSTITUTES_MENU_KEY, ATTENDANCE_MENU_KEY, STUDENTS_MENU_KEY } from "./menu.keys";
import type { TFunction } from "i18next";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { PERMISSIONS } from "@constants/user.roles";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";

export const getSidebarMenuConfig = (t: TFunction) => {
	return [
		{
			key: DASHBOARD_MENU_KEY,
			label: t("layout.sidebar.menuName.dashboard"),
			icon: <WidgetsOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DASHBOARD,
			requiredPermission: PERMISSIONS.ALL_READ, // Dashboard is accessible to all authenticated users
		},
		{
			key: INSTITUTES_MENU_KEY,
			label: t("layout.sidebar.menuName.institutes"),
			icon: <AccountBalanceOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.INSTITUTES,
			requiredPermission: PERMISSIONS.ALL_READ, // Will be updated when institute permissions are available
		},
		{
			key: ATTENDANCE_MENU_KEY,
			label: t("layout.sidebar.menuName.attendance"),
			icon: <EventAvailableOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.ATTENDANCE,
			requiredPermission: PERMISSIONS.ALL_READ,
		},
		{
			key: STUDENTS_MENU_KEY,
			label: t("layout.sidebar.menuName.students") || "Students",
			icon: <SchoolOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.STUDENTS,
			requiredPermission: PERMISSIONS.ALL_READ,
		},
	];
};
